// ==============================|| INTERRUPTOR "OBRAS DE PRUEBA" ||============================== //
//
// Regla del usuario (2026-11-03): "como tenemos el de autorizadas mete un switch
// para que se vean las de prueba, por default están ocultas", "y que sigan
// contando en todos lados mientras esté activado el switch".
//
// Un solo valor para toda la pestaña: vive en sessionStorage con la misma clave
// que useEstadoSesion('verPruebas', false), así que se borra al iniciar o
// cerrar sesión y al emular (limpiarEstadosSesion). El cliente (api/client.ts)
// lo manda como `tests: 1` en cada POST, y el API lo lee en WorkScope::contable
// y en la lista de obras.

export const CLAVE_VER_PRUEBAS = 'verPruebas';

export function verPruebas(): boolean {
  try {
    return sessionStorage.getItem(`filtros:${CLAVE_VER_PRUEBAS}`) === 'true';
  } catch {
    return false;
  }
}
